import SectionHeading from '@/components/base/SectionHeading';
import { testimonials } from '@/mocks/site';

function Testimonials() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-label="用户反馈">
      <SectionHeading
        eyebrow="用户反馈"
        title="他们在网报吃瓜怎么看热点"
        desc="从时间线到报道对比，用户的用法各不相同，但目标都差不多：少开几个网页，把事情看明白。"
        align="center"
      />

      <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((item) => (
          <figure
            key={item.name}
            className="flex h-full flex-col rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-6"
          >
            <i className="ri-double-quotes-l text-3xl text-primary-300" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
              {item.text}
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/80 pt-4">
              <span className="h-10 w-10 shrink-0 overflow-hidden rounded-full">
                <img
                  src={item.avatar}
                  alt={`${item.name} 的头像`}
                  title={`${item.name} - 网报吃瓜用户反馈`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;